import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';

interface Delta {
  ops: any[];
}

// COMMENTED OUT: Color/Highlight helper functions
// const HEX_SHORT_LENGTH = 3;

// const clampByte = (value: number): number => {
//   if (Number.isNaN(value)) return 0;
//   return Math.min(255, Math.max(0, Math.round(value)));
// };

// const toHexByte = (value: number): string => clampByte(value).toString(16).padStart(2, '0').toUpperCase();

// const expandHexShorthand = (hex: string): string => hex.split('').map(ch => ch + ch).join('');

// const trimCssAlpha = (alpha: number): string => {
//   const clamped = Math.min(Math.max(alpha, 0), 1);
//   if (clamped === 0 || clamped === 1) {
//     return clamped.toString();
//   }
//   let str = clamped.toFixed(3);
//   str = str.replace(/0+$/, '').replace(/\.$/, '');
//   return str;
// };

// const normalizeUnityColorToCss = (color: string): string => {
//   if (!color) return color;
//   const trimmed = color.trim();
//   if (!trimmed.startsWith('#')) {
//     return trimmed;
//   }

//   let hex = trimmed.slice(1);
//   if (hex.length === HEX_SHORT_LENGTH) {
//     hex = expandHexShorthand(hex);
//     return `#${hex}`;
//   }

//   if (hex.length === HEX_SHORT_LENGTH + 1) {
//     hex = expandHexShorthand(hex);
//   }

//   if (hex.length === 6) {
//     return `#${hex}`;
//   }

//   if (hex.length === 8) {
//     const r = parseInt(hex.slice(0, 2), 16);
//     const g = parseInt(hex.slice(2, 4), 16);
//     const b = parseInt(hex.slice(4, 6), 16);
//     const alpha = parseInt(hex.slice(6, 8), 16) / 255;
//     if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
//       return trimmed;
//     }
//     if (alpha >= 0.999) {
//       return `#${hex.slice(0, 6)}`;
//     }
//     return `rgba(${clampByte(r)}, ${clampByte(g)}, ${clampByte(b)}, ${trimCssAlpha(alpha)})`;
//   }

//   return trimmed;
// };

// const parseCssAlpha = (value: string): number | null => {
//   if (!value) return null;
//   let numeric = value.trim();
//   if (numeric.endsWith('%')) {
//     const percent = parseFloat(numeric.slice(0, -1));
//     if (Number.isNaN(percent)) return null;
//     return Math.min(Math.max(percent / 100, 0), 1);
//   }
//   const parsed = parseFloat(numeric);
//   if (Number.isNaN(parsed)) return null;
//   return Math.min(Math.max(parsed, 0), 1);
// };

// const cssColorToUnity = (color: string): string | null => {
//   if (!color) return null;
//   const trimmed = color.replace(/!important/gi, '').trim().toLowerCase();
//   if (!trimmed || trimmed === 'initial' || trimmed === 'inherit' || trimmed === 'unset') {
//     return null;
//   }

//   if (trimmed === 'transparent') {
//     return '#00000000';
//   }

//   if (trimmed.startsWith('#')) {
//     let hex = trimmed.slice(1);
//     if (hex.length === HEX_SHORT_LENGTH) {
//       hex = expandHexShorthand(hex);
//     } else if (hex.length === HEX_SHORT_LENGTH + 1) {
//       hex = expandHexShorthand(hex);
//     }
//     if (hex.length === 6 || hex.length === 8) {
//       return `#${hex.toUpperCase()}`;
//     }
//     return `#${hex.toUpperCase()}`;
//   }

//   const rgbMatch = trimmed.match(/^rgba?\(([^)]+)\)$/);
//   if (rgbMatch) {
//     const parts = rgbMatch[1].split(',').map(part => part.trim()).filter(Boolean);
//     if (parts.length < 3) return null;

//     const parseComponent = (value: string): number | null => {
//       if (!value) return null;
//       if (value.endsWith('%')) {
//         const percent = parseFloat(value.slice(0, -1));
//         if (Number.isNaN(percent)) return null;
//         return clampByte((percent / 100) * 255);
//       }
//       const numeric = parseFloat(value);
//       if (Number.isNaN(numeric)) return null;
//       return clampByte(numeric);
//     };

//     const r = parseComponent(parts[0]);
//     const g = parseComponent(parts[1]);
//     const b = parseComponent(parts[2]);
//     if (r === null || g === null || b === null) return null;

//     let alphaHex = '';
//     if (parts.length >= 4) {
//       const alpha = parseCssAlpha(parts[3]);
//       if (alpha !== null) {
//         const alphaByte = clampByte(alpha * 255);
//         if (alphaByte < 255) {
//           alphaHex = toHexByte(alphaByte);
//         }
//       }
//     }

//     const hex = `#${toHexByte(r)}${toHexByte(g)}${toHexByte(b)}${alphaHex}`;
//     return hex;
//   }

//   return null;
// };

// const extractStyleValue = (style: string, property: string): string | null => {
//   if (!style) return null;
//   const regex = new RegExp(`${property}\\s*:\\s*([^;]+)`, 'i');
//   const match = style.match(regex);
//   if (!match) return null;
//   return match[1].replace(/!important/gi, '').trim();
// };

export function convertTMPToQuill(text: string): string {
  console.log('Original text from Unity:', text);
  if (!text) return text;

  // If text is ONLY newlines/whitespace, treat as empty
  if (text.trim() === '') return '';

  text = text.replace(/\n/g, '<br>');

  // Strip color tags from inside mark tags to prevent Unity's contrast color from being preserved
  // Unity may add white color to highlighted text for readability, but we want Quill to use default text color
  // COMMENTED OUT: Color/Highlight functionality
  // text = text.replace(/<mark=([^>]+)>((?:(?!<\/mark>).)*)<\/mark>/gi, (_match, colorValue, content) => {
  //   const cleanContent = content.replace(/<\/?color[^>]*>/gi, '');
  //   return `<mark=${colorValue}>${cleanContent}</mark>`;
  // });

  // Convert TMP color and highlight tags so Quill can render them
  // COMMENTED OUT: Color/Highlight functionality
  // text = text.replace(/<color=([^>]+)>/gi, (_match, colorValue) => {
  //   const cssColor = normalizeUnityColorToCss(colorValue);
  //   return `<span style="color: ${cssColor}">`;
  // });
  // text = text.replace(/<\/color>/gi, '</span>');
  // text = text.replace(/<mark=([^>]+)>/gi, (_match, colorValue) => {
  //   const cssColor = normalizeUnityColorToCss(colorValue);
  //   return `<span style="background-color: ${cssColor}">`;
  // });
  // text = text.replace(/<\/mark>/gi, '</span>');
  
  // Handle indent tags - convert <indent=XX%></indent> to [indent=XX][/indent]
  text = text.replace(/<indent=(\d+)%><\/indent>/g, '[indent=$1]');
  text = text.replace(/<indent=(\d+)%>/g, '[indent=$1]');
  text = text.replace(/<\/indent>/g, '[/indent]');
  
  // Check for list patterns
  const orderedListPattern = /\[indent=4\]\d+\. \[indent=18\].*?\[\/indent\](?:\[\/indent\])?/;
  const bulletListPattern = /\[indent=4\]•\[indent=14\].*?\[\/indent\](?:\[\/indent\])?/;
  const hasOrderedList = orderedListPattern.test(text);
  const hasBulletList = bulletListPattern.test(text);
  
  // Handle reference tags - convert <sup><link> to [ref]
  text = text.replace(/<sup>(<link="[^"]+">[\d]+<\/link>(,\s*<link="[^"]+">[\d]+<\/link>)*)<\/sup>/g, function(_match, p1) {
    return p1.replace(/<link="([^"]+)">[\d]+<\/link>/g, '[ref]$1[/ref]');
  });
  text = text.replace(/<sup><link="([^"]+)">([^<]+)<\/link><\/sup>/g, '[ref]$1[/ref]');
  text = text.replace(/<sup><link>([^<]+)<\/link><\/sup>/g, '[ref]$1[/ref]');
  
  // If no lists, do quick conversion
  if (!hasOrderedList && !hasBulletList) {
    text = text
      .replace(/<b>/g, '<strong>')
      .replace(/<\/b>/g, '</strong>')
      .replace(/<i>/g, '<em>')
      .replace(/<\/i>/g, '</em>')
      .replace(/\[sup\](\[link="[^"]+"\][\d]+\[\/link\](,\s*\[link="[^"]+"\][\d]+\[\/link\])*)\[\/sup\]/g, function(_match, p1) {
        return p1.replace(/\[link="([^"]+)"\][\d]+\[\/link\]/g, '[ref]$1[/ref]');
      })
      .replace(/\[sup\]\[link="([^"]+)"\][\d]+\[\/link\]\[\/sup\]/g, '[ref]$1[/ref]')
      .replace(/<link="([^"]+)">/g, '[link="$1"]')
      .replace(/<link>/g, '[link]')
      .replace(/<\/link>/g, '[/link]')
      .replace(/<s>/g, '[s]')
      .replace(/<\/s>/g, '[/s]');
    // Keep <sub> and <sup> as HTML tags for Quill to render properly
    
    if (!text.includes('<p>')) text = `<p>${text}</p>`;
    console.log('Final converted text for Quill to display:', text);
    return text;
  }
  
  // Complex list handling
  interface Block {
    type: string;
    content: string;
    items: any[];
    listType?: string;
  }
  const blocks: Block[] = [];
  let lastIndex = 0;
  let currentBlock: Block = { type: 'content', content: '', items: [] };
  
  const addBlock = () => {
    if (currentBlock.content.trim() || currentBlock.items.length > 0) {
      blocks.push({...currentBlock});
      currentBlock = { type: 'content', content: '', items: [] };
    }
  };
  
  const scanText = (regex: RegExp, type: string) => {
    let match;
    regex.lastIndex = 0;
    
    while ((match = regex.exec(text)) !== null) {
      const matchStart = match.index;
      const matchEnd = matchStart + match[0].length;
      
      if (matchStart > lastIndex) {
        const contentBetween = text.substring(lastIndex, matchStart).trim();
        if (contentBetween) {
          if (currentBlock.type === 'list') {
            addBlock();
          }
          currentBlock.type = 'content';
          currentBlock.content = text.substring(lastIndex, matchStart);
          addBlock();
        }
      }
      
      if (currentBlock.type !== 'list') {
        addBlock();
        currentBlock.type = 'list';
        currentBlock.listType = type;
        currentBlock.items = [];
      }
      
      if (type === 'ordered') {
        currentBlock.items.push({
          number: match[1],
          content: match[2]
        });
      } else {
        currentBlock.items.push({
          content: match[1]
        });
      }
      
      lastIndex = matchEnd;
    }
  };
  
  const orderedRegex = /\[indent=4\](\d+)\. \[indent=18\](.*?)\[\/indent\](?:\[\/indent\])?/g;
  const bulletRegex = /\[indent=4\]•\[indent=14\](.*?)\[\/indent\](?:\[\/indent\])?/g;
  
  scanText(orderedRegex, 'ordered');
  scanText(bulletRegex, 'bullet');
  
  if (lastIndex < text.length) {
    if (currentBlock.type === 'list') {
      addBlock();
    }
    currentBlock.type = 'content';
    currentBlock.content = text.substring(lastIndex);
    addBlock();
  } else if (currentBlock.type === 'list') {
    addBlock();
  }
  
  // Convert blocks to HTML
  const segments: Array<{ type: string; text?: string; html?: string }> = [];

  blocks.forEach((block, index) => {
    if (block.type === 'content') {
      let content = block.content;

      // If this content block is right before a list, trim trailing <br>
      // BUT only if it's a single <br>, not multiple (which represent intentional blank lines)
      if (index < blocks.length - 1 && blocks[index + 1].type === 'list') {
        // Match trailing sequence of <br> tags with optional whitespace
        const match = content.match(/(\s*(?:<br\s*\/?>\s*)+)$/gi);
        if (match && match[0]) {
          // Count how many <br> tags are in the trailing sequence
          const brCount = (match[0].match(/<br\s*\/?>/gi) || []).length;

          // Only remove the trailing <br> if there's exactly ONE (not multiple)
          // Multiple <br> tags = user wants blank lines before the list
          if (brCount === 1) {
            content = content.replace(/\s*<br\s*\/?>(\s*)$/gi, '$1');
          }
        }
      }

      // If this content block is right after a list, trim leading <br>
      if (index > 0 && blocks[index - 1].type === 'list') {
        content = content.replace(/^<br\s*\/?>/gi, '');
      }

      // Convert <br> sequences to proper paragraph structure for Quill
      // Split content by <br> to create separate paragraphs
      const parts = content.split(/<br\s*\/?>/gi).filter((part, index, arr) => {
        // Remove trailing empty string that results from content ending with <br>
        return index < arr.length - 1 || part.trim() !== '';
      });
      const paragraphs = parts.map(part => {
        const trimmed = part.trim();
        // Empty parts become <p><br></p> (empty paragraph for blank lines)
        // Non-empty parts become <p>content</p>
        return trimmed ? `<p>${part}</p>` : '<p><br></p>';
      });

      segments.push({
        type: 'content',
        html: paragraphs.join('')
      });
    } else if (block.type === 'list') {
      const listTag = block.listType === 'ordered' ? 'ol' : 'ul';
      const items = block.items?.map(item => {
        // Convert TMP formatting to HTML before wrapping in <li>
        let cleanContent = item.content
          .replace(/<b>/g, '<strong>').replace(/<\/b>/g, '</strong>')
          .replace(/<i>/g, '<em>').replace(/<\/i>/g, '</em>')
          .replace(/<link="([^"]+)">/g, '[link="$1"]').replace(/<link>/g, '[link]').replace(/<\/link>/g, '[/link]')
          .replace(/<s>/g, '[s]').replace(/<\/s>/g, '[/s]');
        return `<li>${cleanContent}</li>`;
      }).join('') || '';
      segments.push({
        type: block.listType === 'ordered' ? 'ordered-list' : 'bullet-list',
        html: `<${listTag}>${items}</${listTag}>`
      });
    }
  });
  
  // Combine and finalize
  let result = segments.reduce((acc, seg) => acc + (seg.html || ''), '');
  
  result = result
    .replace(/<b>/g, '<strong>').replace(/<\/b>/g, '</strong>')
    .replace(/<i>/g, '<em>').replace(/<\/i>/g, '</em>')
    .replace(/<link="([^"]+)">/g, '[link="$1"]').replace(/<link>/g, '[link]').replace(/<\/link>/g, '[/link]')
    .replace(/<s>/g, '[s]').replace(/<\/s>/g, '[/s]');
  // Keep <sub> and <sup> as HTML tags for Quill to render properly
  
  if (!result.includes('<p>') && !result.includes('<ul>') && !result.includes('<ol>')) {
    result = `<p>${result}</p>`;
  }

  console.log('Final converted text for Quill to display:', result);
  return result;
}

export function convertQuillToTMP(delta: Delta): string {
  console.log('convertQuillToTMP called with Delta:', delta);
  
  // Convert Delta to HTML
  const converter = new QuillDeltaToHtmlConverter(delta.ops, {
    inlineStyles: true,
    paragraphTag: 'p'
  });
  
  let html = converter.convert();
  
  // Parse HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  
  // COMMENTED OUT: Color/Highlight functionality
  const convertStyleSpansToTMP = (htmlContent: string): string => {
    // if (!htmlContent || !htmlContent.includes('style=')) {
    //   return htmlContent;
    // }
    // const tempDoc = parser.parseFromString(`<div>${htmlContent}</div>`, 'text/html');
    // const spans = Array.from(tempDoc.body.querySelectorAll('span[style]')) as HTMLElement[];
    // spans.reverse().forEach(span => {
    //   const styleAttr = span.getAttribute('style');
    //   if (!styleAttr) return;
    //   const colorValue = extractStyleValue(styleAttr, 'color');
    //   const backgroundValue = extractStyleValue(styleAttr, 'background-color');
    //   const unityColor = colorValue ? cssColorToUnity(colorValue) : null;
    //   const unityBackground = backgroundValue ? cssColorToUnity(backgroundValue) : null;
    //   if (!unityColor && !unityBackground) {
    //     return;
    //   }
    //   let replacement = span.innerHTML;
    //   if (unityColor) {
    //     replacement = `<color=${unityColor}>${replacement}</color>`;
    //   }
    //   if (unityBackground) {
    //     replacement = `<mark=${unityBackground}>${replacement}</mark>`;
    //   }
    //   span.replaceWith(tempDoc.createTextNode(replacement));
    // });
    // Extract inner content from the wrapper div, not body.innerHTML which includes the div
    // return tempDoc.body.firstElementChild?.innerHTML || htmlContent;
    return htmlContent; // Return as-is without color/highlight conversion
  };

  // Helper to convert formatting tags
  const convertFormattingTags = (htmlContent: string) => {
    let converted = convertStyleSpansToTMP(htmlContent)
      // Handle multiple adjacent [ref] tags
      .replace(/(\[ref\]([^\[\]]+)\[\/ref\])(,\s*\[ref\]([^\[\]]+)\[\/ref\])+/g, function(match) {
        let counter = 1;
        let result = '<sup>';
        result += match.replace(/\[ref\]([^\[\]]+)\[\/ref\]/g, function(_m, content) {
          const link = `<link="${content}">${counter}</link>`;
          counter++;
          return link;
        });
        result += '</sup>';
        return result;
      })
      // Handle single [ref] tags
      .replace(/\[ref\]([^\[]+)\[\/ref\]/g, '<sup><link="$1">1</link></sup>')
      // Convert indent tags back
      .replace(/\[indent=(\d+)\]/g, '<indent=$1%>')
      .replace(/\[\/indent\]/g, '</indent>')
      // Handle other square bracket formats
      .replace(/\[link="([^"]+)"\]([^\[]+)\[\/link\]/g, '<link="$1">$2</link>')
      .replace(/\[link\]([^\[]+)\[\/link\]/g, '<link>$1</link>')
      .replace(/\[sup\]([^\[]+)\[\/sup\]/g, '<sup>$1</sup>')
      .replace(/\[sub\]([^\[]+)\[\/sub\]/g, '<sub>$1</sub>')
      .replace(/\[s\]([^\[]+)\[\/s\]/g, '<s>$1</s>');
    
    // Handle standard formatting
    return converted
      .replace(/<strong>/g, '<b>')
      .replace(/<\/strong>/g, '</b>')
      .replace(/<em>/g, '<i>')
      .replace(/<\/em>/g, '</i>')
      .replace(/<u>/g, '<u>')
      .replace(/<\/u>/g, '</u>')
      .replace(/<br\/>/g, '<br>')
      .replace(/<s>/g, '<s>')
      .replace(/<\/s>/g, '</s>')
      .replace(/<sub>/g, '<sub>')
      .replace(/<\/sub>/g, '</sub>');
  };
  
  // Convert lists to TMP format
  const allLists = doc.querySelectorAll('ol, ul');
  allLists.forEach(list => {
    const isOrdered = list.tagName.toLowerCase() === 'ol';
    const liElements = list.querySelectorAll('li');
    
    const lines: string[] = [];
    liElements.forEach((li, index) => {
      const content = convertFormattingTags(li.innerHTML);
      if (isOrdered) {
        lines.push(`<indent=4%>${index + 1}. <indent=18%>${content}</indent></indent>`);
      } else {
        lines.push(`<indent=4%>•<indent=14%>${content}</indent></indent>`);
      }
    });

    // Add leading and trailing newline to prevent list from overlapping text
    const replacedText = '\n' + lines.join('\n') + '\n';
    list.replaceWith(document.createTextNode(replacedText));
  });
  
  // Final post-processing
  let result = doc.body.innerHTML
    .replace(/<strong>/g, '<b>')
    .replace(/<\/strong>/g, '</b>')
    .replace(/<em>/g, '<i>')
    .replace(/<\/em>/g, '</i>')
    .replace(/<br\/>/g, '<br>')
    .replace(/<p><br><\/p>/gi, '<p></p>')  // Normalize empty paragraphs (remove redundant br)
    .replace(/<\/p>\s*<p>/g, '\n')  // Preserve paragraph breaks
    .replace(/<\/?p>/g, '')         // Remove remaining opening/closing p tags
    .replace(/<br\s*\/?>/gi, '\n')  // Convert remaining br tags to newlines
    .replace(/^\n+|\n+$/g, '');     // Trim leading and trailing newlines (fixes empty editor showing \n)
  
  result = convertFormattingTags(result);
  
  // Decode HTML entities
  const textArea = document.createElement('textarea');
  textArea.innerHTML = result;
  result = textArea.value;
  
  console.log('Sent back to Unity:', result);
  return result;
}
